import React from "react"

export default function TitleBar({ content }) {
  if (typeof content === "string" || content instanceof String) {
    return (
      <h2 className="text-gray-800 text-lg leading-normal font-semibold">
        {content}
      </h2>
    )
  }

  return content
}
